import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LookUpKeyValueforDomainList } from '../model/lov';
import { v4 as uuid } from 'uuid';
import { Subject } from 'rxjs';
import { DeleteLocationGroupResponse, LocationZoneModel, LocationGroupMaster, LocationGroupRequest } from '../model/location-zone';
import { Facility, FacilitySummay } from '../model/facility';
import { PrinterConfigRequest, PrinterConfigResponse } from '../model/printer-configs';
import { BehaviorSubject } from 'rxjs';
import { CustomerResponse } from '../model/customer';

@Injectable({
  providedIn: 'root'
})
export class PrinterConfigService {
  fcyId: string = '0';
  deleteSpinner = false;
  private deleteCalled = new Subject<any>();
  currentAction = '';
  currentaction$ = new BehaviorSubject(this.currentAction);
  deleteMethodCalled$ = this.deleteCalled.asObservable();
  constructor(private http: HttpClient) { }

  getKeyValue(domainList: string[],facility?: string, customerId?: string,buId?:string): Observable<LookUpKeyValueforDomainList> {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid()
      },
      params: { 
        active: 'Y',
        lookupNames: domainList,
        fcyId: facility ? facility : '0',
        cusId: customerId ? customerId : '0',
        buId: buId ? buId : '0'
        }
    };
    return this.http.get<LookUpKeyValueforDomainList>(environment.apiLookupURL,httpOptions);
  }

  getprinterKeyValue( lookupCode:string, domainList: string[] ): Observable<LookUpKeyValueforDomainList> {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid(),
      },
      params: { active: 'Y', lookupCode : lookupCode, lookupName : domainList }
    };
    return this.http.get<LookUpKeyValueforDomainList>(environment.apiLookupNameValueURL, httpOptions);
  }
  
  getFacilitiesList(): Observable<FacilitySummay> {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid()
      },
      params: { pageLimit: '120', page: '0' }
    };
    return this.http.get<FacilitySummay>(environment.apiFacilityURL, httpOptions);
  }
  getFacilitiesListPrinter(custId:string): Observable<CustomerResponse> {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid()
      },
      params: { pageLimit: '120', page: '0',customerId:custId,responseFilter:'details'}
    };
    return this.http.get<CustomerResponse>(environment.apiCustomerURL, httpOptions);
  }
  getPrinterConfigDetails(custId,facility, printerName, printerType, printerReq, page, pageLimit, printerConfigId) {

    let params = new HttpParams();
    if (custId) {
      params = params.append('custId', custId);
    }
    if (facility) {
      params = params.append('fcyId', facility);
    }
    if (printerName) {
      params = params.append('printerName', printerName);
    }
    if (printerType) {
      params = params.append('printerType', printerType);
    }
    if (printerReq) {
      params = params.append('requestor', printerReq);
    }
    params = params.append('page', page);
    params = params.append('pageLimit', pageLimit);
    if (printerConfigId) {
      params = params.append('printerConfigId', printerConfigId);
    }

    const httpOptions = {
      params,
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid()
      }
    };

    return this.http.get<PrinterConfigResponse>(environment.apiPrinterUrl, httpOptions);
  }

  updatePrinterDetails(printerId: number, printerConfigRequest: PrinterConfigRequest): Observable<PrinterConfigResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      APPID: environment.apiBussServAPPID,
      UUID: uuid(),
    });
    const options = {
      headers,
    };
    return this.http.patch<PrinterConfigResponse>(environment.apiPrinterUrl + "/" + printerId.toString(), JSON.stringify(printerConfigRequest), options);
  }

  savePrinterDetails(printerConfigRequest: PrinterConfigRequest): Observable<PrinterConfigResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      APPID: environment.apiBussServAPPID,
      UUID: uuid(),
    });
    const options = {
      headers,
    };
    return this.http.post<PrinterConfigResponse>(environment.apiPrinterUrl, JSON.stringify(printerConfigRequest), options);
  }

  deletePrinterConfigs(printerId: number) {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json',
        APPID: environment.apiBussServAPPID,
        UUID: uuid()
      }
    };
    return this.http.delete<PrinterConfigResponse>(environment.apiPrinterUrl + '/' + printerId.toString(), httpOptions);
  }

  deleteSuccess(success: boolean) {
    this.deleteCalled.next(success);
  }


}
